import { cn as e } from "../shared/utils.js";
import { Textarea as t } from "./textarea.js";
import { forwardRef as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
import { Input as a } from "@base-ui/react/input";
//#region src/input/input-group.tsx
var o = i([
	"group/input-group relative inline-flex w-full min-w-0 items-center rounded-md group-focus-ring transition-base bg-field-bg-primary outline-none",
	"has-[>textarea]:h-auto",
	"has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:h-auto",
	"has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:h-auto",
	"has-[[data-slot=input-group-control][data-disabled]]:bg-field-bg-disabled",
	"**:[input]:px-3 **:[textarea]:p-3",
	"has-data-[align=inline-start]:**:[input]:ps-2",
	"has-data-[align=inline-end]:**:[input]:pe-2",
	"has-data-[align=block-end]:**:[input]:pt-2",
	"has-data-[align=block-start]:**:[input]:pb-2",
	"**:[textarea]:min-h-[82px]"
], {
	variants: { size: {
		sm: "h-8",
		md: "h-10"
	} },
	defaultVariants: { size: "md" }
}), s = n(({ className: t, size: n, ...i }, a) => /* @__PURE__ */ r("div", {
	ref: a,
	role: "group",
	"data-slot": "input-group",
	"data-testid": "input-group",
	className: e(o({ size: n }), t),
	...i
})), c = n(({ className: t, ...n }, i) => /* @__PURE__ */ r(a, {
	ref: i,
	"data-slot": "input-group-control",
	"data-testid": "input-group-control",
	className: e("text-text-primary placeholder:text-text-tertiary data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled transition-base h-full min-w-0 flex-1 rounded-md border-0 bg-transparent text-base text-ellipsis outline-none group-has-data-[align=inline-end]/input-group:rounded-r-none group-has-data-[align=inline-start]/input-group:rounded-l-none", t),
	...n
})), l = n(({ className: n, rows: i, ...a }, o) => /* @__PURE__ */ r(t, {
	ref: o,
	unstyled: !0,
	"data-slot": "input-group-control",
	"data-testid": "input-group-control",
	rows: i,
	className: e("text-text-primary placeholder:text-text-tertiary data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled transition-base w-full min-w-0 flex-1 resize-none rounded-md border-0 bg-transparent text-base outline-none group-has-data-[align=inline-end]/input-group:rounded-r-none group-has-data-[align=inline-start]/input-group:rounded-l-none", n),
	...a
})), u = i([
	"flex items-center justify-center gap-2 py-1.5 select-none text-base h-full text-text-secondary transition-base group-has-data-disabled/input-group:text-text-disabled",
	"[&>svg:not([class*=size-])]:size-4",
	"cursor-text",
	"group-has-data-disabled/input-group:cursor-default"
], {
	variants: {
		align: {
			"inline-start": "order-first ps-3",
			"inline-end": "order-last pe-3",
			"block-start": "order-first w-full justify-start px-1.5 pt-3 [.border-b]:pb-3",
			"block-end": "order-last w-full justify-start px-1.5 pb-3 [.border-t]:pt-3"
		},
		appearance: {
			subtle: "border-0",
			filled: "bg-field-bg-secondary text-text-secondary px-3"
		}
	},
	compoundVariants: [{
		align: "inline-start",
		appearance: "filled",
		className: "rounded-l-md"
	}, {
		align: "inline-end",
		appearance: "filled",
		className: "rounded-r-md"
	}],
	defaultVariants: {
		align: "inline-start",
		appearance: "subtle"
	}
}), d = n(({ className: t, align: n, appearance: i, ...a }, o) => /* @__PURE__ */ r("div", {
	ref: o,
	role: "group",
	"data-slot": "input-group-addon",
	"data-testid": "input-group-addon",
	"data-align": n,
	"data-appearance": i,
	className: e(u({
		align: n,
		appearance: i
	}), t),
	onMouseDown: (e) => {
		if (e.target.closest("button, a, input, select, textarea, [role='button'], [role='combobox'], [role='listbox'], [data-slot='select-trigger']")) return;
		e.preventDefault();
		let t = e.currentTarget.parentElement, n = t?.querySelector("input, textarea");
		n && !t?.querySelector("input:focus, textarea:focus") && n.focus();
	},
	...a
})), f = n(({ className: t, ...n }, i) => /* @__PURE__ */ r("span", {
	ref: i,
	"data-slot": "input-group-text",
	"data-testid": "input-group-text",
	className: e("text-text-tertiary group-has-data-disabled/input-group:text-text-disabled line-clamp-1 flex items-center gap-2 text-base whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:-mx-px [&>svg:not([class*=size-])]:size-4", t),
	...n
}));
s.displayName = "InputGroup.Root", c.displayName = a.displayName, l.displayName = "Textarea", d.displayName = "InputGroup.Addon", f.displayName = "InputGroup.Text";
var p = {
	Root: s,
	Input: c,
	Textarea: l,
	Addon: d,
	Text: f
};
//#endregion
export { p as InputGroup, u as inputGroupAddonVariants, o as inputGroupVariants };
